


























import Popper from "popper.js";
import { defineComponent, nextTick, PropType, ref } from "@vue/composition-api";

import { Session } from "@/tools/msa/models";
import { save, download, load } from "@/tools/msa/extensions/persistence";

export default defineComponent({
  name: "FileButton",
  props: {
    session: { type: Object as PropType<Session>, required: true }
  },
  setup(props, context) {
    const button = ref<HTMLElement | null>(null);
    const popover = ref<HTMLElement | null>(null);
    const popper = ref<Popper | null>(null);

    const close = (event: Event) => {
      const element = popover.value;

      if (
        element &&
        element.offsetParent &&
        event.target &&
        !element.contains(event.target as Node)
      )
        hide();
    };

    const hide = () => {
      if (popper.value) {
        popper.value.destroy();
        popper.value = null;
      }

      document.removeEventListener("click", close);
    };

    const show = () => {
      if (!button.value || !popover.value) return;

      popper.value = new Popper(button.value, popover.value, {
        placement: "bottom"
      });

      window.setTimeout(() => {
        document.addEventListener("click", close, true);
      }, 100);

      nextTick(() => {
        if (popper.value) popper.value.update();
      });
    };

    const openFile = () => {
      hide();
      const input: HTMLInputElement = document.createElement("input");
      input.type = "file";
      input.accept = ".vrbmsa";
      input.dispatchEvent(new MouseEvent("click"));
      input.addEventListener("input", e => {
        context.emit("opened", input.files![0]);
      });
    };

    const saveFile = () => {
      hide();
      save(props.session).then(data =>
        download(data, props.session.file.name.replace(/\.[^/.]+$/, ""))
      );
    };

    return {
      button,
      popover,
      popper,
      hide,
      show,
      openFile,
      saveFile
    };
  }
});
